import { useRef } from "react";

interface InteractionGate {
    hasInteracted: () => boolean;
    markInteracted: () => void;
}

export default function useInteractionGate(): InteractionGate {
    const interacted = useRef(false);

    return {
        hasInteracted: () => interacted.current,
        markInteracted: () => { interacted.current = true; },
    };
}
